<script>

    import {get} from "svelte/store";
    import {publishConfigStore} from "../core/app-store.js";
    import {cartTotalStore} from "../cart/cart-store.js";
    import {onDestroy, onMount} from "svelte";
    import {deliveryStore} from "./../orders/orders-store.js";
    import {getTotals} from "./../orders/orders.js";

    export let hideTotal = false;
    export let hideDelivery = false;

    const publishConfig = get(publishConfigStore);

    let currency = publishConfig.currency ? ` ${publishConfig.currency}` : '';

    let itemsPrice;
    let deliveryPrice;
    let totalPrice;

    const storeSubscriptions = [
        deliveryStore.subscribe(() => {calculateFinalPrice();}),
        cartTotalStore.subscribe(() => {calculateFinalPrice();})
    ];

    function calculateFinalPrice () {

        const totals = getTotals();

        itemsPrice = totals.itemsPrice;
        deliveryPrice = totals.deliveryPrice;
        totalPrice = totals.totalPrice;
    }

    onMount(() => {
        calculateFinalPrice();
    });

    onDestroy(() => {
        for (let i = 0; i < storeSubscriptions.length; i++){
            storeSubscriptions[i]();
        }
    });

</script>

<style>

    ul {
        display: flex;
        flex-direction: column;
        gap: .25rem;
        padding: 1rem 0;
        border-top: 1px dashed #cacacaaa;
        border-bottom: 1px dashed #cacacaaa;
        margin-bottom: 1rem;
    }
    li {
        display: flex;
        justify-content: space-between;
    }

    .bold {
        font-weight: 600;
    }
    .final {
        font-size: var(--fs-150);
        font-weight: 600;
    }

</style>

<div>

    {#if (itemsPrice || deliveryPrice || totalPrice)}
        <ul>

            {#if (itemsPrice)}
                <li>
                    <div>Сумма заказа</div>
                    <div class="bold">{itemsPrice} ₽</div>
                </li>
            {/if}

            {#if (deliveryPrice && !hideDelivery)}
                <li>
                    <div>Стоимость доставки</div>
                    <div class="bold">{deliveryPrice}{currency}</div>
                </li>
            {/if}

            {#if (totalPrice && !hideTotal)}
                <li class="final">
                    <div>Итого</div>
                    <div>{totalPrice}{currency}</div>
                </li>
            {/if}

        </ul>
    {/if}

</div>
